import AppContainer from "../../container";
import { IAuthService, AuthService } from "../../services/auth.service";

export default function LogoutPage() {
  const authService: IAuthService = AppContainer.get(AuthService);
  authService.logout();

  return null;
}
